import React from 'react';
import {
  FDBodyText, FDBox, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { RoadmapExplorerGoalFundedProgress } from 'Components/UI/roadmapExplorer/goalsAccordion/goalFundedProgress';
import { dataAttrs } from 'Helpers/Testing';
import { OutcomeActionLayout } from './components/OutcomeActionLayout/OutcomeActionLayout';
import { OutcomeInvestmentDetailsSection } from './components/OutcomeInvestmentDetailsSection/OutcomeInvestmentDetailsSection';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('reason', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .done();

const RoadmapGoalDetailOutcomeLayout = () => {
  const parentRef = React.useRef(null);
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();

  return (
    <FDStack direction={'column'} spacing={5} width={'100%'} {...dataAttrs('goal-detail-outcome-layout')}>
      <FDStack direction={'column'} spacing={2} width={'100%'} alignItems={'center'}>
        <MetaControlField attr={'description'} simpleRootStyle />
      </FDStack>
      <div ref={parentRef}>
        <RoadmapExplorerGoalFundedProgress
          hasIcon={false}
          resource={resource}
          width={parentRef?.current?.offsetWidth ?? 200}
          progressDescription={resource.attr('progressDescription')}
          rightAlignedDescription={resource.attr('goalAmount')}
          progressValue={resource.attr('progress')}
        />
      </div>
      <FDPaper appearance={'flat'} width={'100%'}>
        <FDBox paddingX={isMobile ? 2 : 3} paddingY={5} width={'100%'}>
          <FDStack direction={'column'} spacing={2} width={'100%'}>
            <MetaControlField attr={'actionSectionTitle'} />
            <MetaCollectionRenderer
              collection={resource.attr('actions')}
              layout={OutcomeActionLayout}
              metaOverrideSet={metaOverrideSet}
            />
            <FDStack direction={'column'} spacing={2} width={'100%'}>
              <FDStack direction={'row'} spacing={6} width={'100%'}>
                <MetaControlField attr={'totalAmount'} />
                <MetaControlField attr={'targetDate'} />
              </FDStack>
              {!!resource.attr('supportingMultipleGoalsDisclaimer') && (
                <MetaControlField attr={'supportingMultipleGoalsDisclaimer'} />
              )}
            </FDStack>
          </FDStack>
        </FDBox>
      </FDPaper>
      <OutcomeInvestmentDetailsSection />
    </FDStack>
  );
};

export { RoadmapGoalDetailOutcomeLayout };
